import { render } from "./RequestDetailsModal.vue?vue&type=template&id=0ea63774"
import script from "./RequestDetailsModal.vue?vue&type=script&lang=js"
export * from "./RequestDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__